<template>
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="128.000000pt"
    height="128.000000pt"
    viewBox="0 0 128.000000 128.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0.000000,128.000000) scale(0.100000,-0.100000)"
      fill="#000000"
      stroke="none"
    >
      <path
        d="M440 1244 c-30 -8 -67 -18 -81 -23 -15 -5 -33 -5 -40 0 -23 14 -93
10 -117 -7 -49 -34 -52 -55 -52 -333 0 -274 -3 -297 -47 -343 -23 -24 -27 -58
-6 -58 5 0 42 43 83 95 63 80 79 95 100 93 48 -6 35 -38 -65 -158 -52 -63 -95
-122 -95 -130 0 -9 20 -36 45 -60 50 -49 50 -49 32 -74 -12 -16 -19 -12 -82
44 -86 76 -91 84 -71 115 20 31 20 45 1 45 -21 0 -49 -62 -42 -92 4 -14 38
-51 76 -84 54 -45 69 -64 65 -79 -13 -51 -16 -133 -5 -153 11 -22 16 -22 241
-22 l229 0 25 33 c74 97 75 224 3 319 -15 19 -27 42 -27 50 0 19 -27 44 -62
57 -25 9 -26 12 -16 39 17 43 -3 81 -78 152 -35 32 -64 62 -64 66 0 4 9 22 21
41 14 23 25 31 33 24 6 -5 29 -14 52 -21 50 -15 89 1 129 55 23 29 26 41 20
74 -6 34 -4 40 14 46 60 19 109 175 55 175 -9 0 -14 -11 -14 -35 0 -80 -53
-125 -147 -125 -42 0 -50 4 -64 29 -30 52 -90 44 -120 -16 -15 -29 -16 -30
-36 -14 -47 37 -56 97 -23 160 22 43 70 71 122 71 19 0 39 5 45 11 20 20 129
6 164 -20 17 -13 37 -20 46 -17 14 6 13 9 -3 28 -48 54 -135 69 -244 42z
m-155 -50 c14 -6 14 -9 1 -29 -22 -33 -38 -103 -31 -136 4 -15 17 -45 31 -64
l24 -36 -57 -94 c-32 -52 -60 -94 -63 -95 -9 0 5 414 14 428 7 12 40 30 58 31
3 1 14 -2 23 -5z m176 -224 c9 -24 18 -30 53 -35 24 -4 53 -5 66 -3 18 2 25
-3 31 -24 6 -22 1 -33 -26 -62 -38 -42 -60 -44 -117 -15 l-42 21 -20 -24 c-12
-13 -28 -34 -36 -46 l-15 -23 -33 33 -32 34 29 45 c21 34 35 46 52 45 19 -1
25 5 27 29 7 59 46 75 63 25z m-73 -288 c136 -131 138 -138 57 -223 -83 -87
-75 -112 40 -123 55 -4 76 -2 92 9 20 14 23 13 41 -10 48 -61 48 -164 0 -242
l-20 -33 -214 0 -214 0 0 53 c0 30 3 56 6 60 3 3 29 -12 56 -34 27 -21 54 -39
58 -39 31 0 118 25 133 38 21 19 22 63 2 102 -18 35 -38 40 -93 22 -43 -14
-44 -14 -73 14 -19 18 -28 36 -25 47 2 10 -2 41 -10 68 l-15 51 43 54 c112
141 115 148 73 189 -33 34 -70 32 -106 -6 -16 -17 -29 -28 -29 -23 0 11 73
134 80 134 3 -1 56 -49 118 -108z m177 -252 c11 -9 11 -17 3 -35 -10 -22 -16
-24 -74 -22 -35 1 -64 6 -64 11 0 6 12 23 28 39 22 24 33 28 60 23 19 -3 40
-10 47 -16z m-365 -79 c0 -12 -5 -11 -21 6 -13 13 -18 26 -14 34 6 9 11 7 22
-6 7 -11 13 -26 13 -34z m62 -128 c18 -16 22 -16 65 0 49 18 66 13 76 -24 7
-28 -15 -46 -67 -53 -41 -7 -49 -4 -85 25 -34 27 -38 34 -28 50 14 23 16 23
39 2z"
      />
      <path
        d="M894 1116 c-17 -8 -47 -28 -67 -45 -79 -70 -108 -159 -82 -251 31
-107 34 -97 -54 -185 -80 -79 -95 -107 -69 -133 23 -23 44 -12 118 64 41 41
82 79 91 84 11 6 34 2 68 -10 95 -37 183 -22 257 43 106 94 122 224 41 343
-46 68 -117 104 -206 104 -36 -1 -80 -7 -97 -14z m223 -62 c75 -60 102 -128
88 -220 -8 -57 -58 -122 -115 -152 -37 -19 -57 -23 -111 -20 -82 4 -135 36
-175 104 -49 84 -32 207 38 270 48 44 79 54 160 52 68 -3 80 -6 115 -34z"
      />
      <path
        d="M965 1000 c-4 -6 -3 -44 0 -85 6 -64 10 -75 26 -75 20 0 27 26 31
115 3 47 2 50 -24 53 -14 2 -29 -2 -33 -8z"
      />
      <path
        d="M980 766 c0 -9 7 -16 16 -16 17 0 14 22 -4 28 -7 2 -12 -3 -12 -12z"
      />
      <path
        d="M750 335 c-18 -19 -21 -28 -12 -37 9 -9 16 -7 32 7 11 10 20 24 20
31 0 24 -17 23 -40 -1z"
      />
      <path
        d="M745 230 c-11 -18 10 -32 41 -28 40 4 38 32 -3 36 -17 2 -34 -2 -38
-8z"
      />
      <path
        d="M735 139 c-8 -12 23 -49 42 -49 19 0 16 24 -5 43 -22 20 -28 21 -37
6z"
      />
    </g>
  </svg>
</template>

<script>
export default {}
</script>

<style></style>
